module.exports = __webpack_public_path__ + "static/media/birbs.bc41e422.png";